/** 全局表格 max-height（供各页 el-table 使用，表头固定、表体滚动） */
let tableMaxHeight = 436
let resizeHandler = null

/**
 * 绑定 window 尺寸变化时重算 tableMaxHeight（在 main.js 中只调用一次）
 * @param {{ reservedHeight?: number, minHeight?: number }} [options]
 */
export const bindTableMaxHeightResize = (options = {}) => {
  const reservedHeight = options.reservedHeight || 436
  const minHeight = options.minHeight || 280

  if (resizeHandler) {
    window.removeEventListener('resize', resizeHandler)
  }

  resizeHandler = () => {
    tableMaxHeight = Math.max(minHeight, window.innerHeight - reservedHeight)
  }
  resizeHandler()
  window.addEventListener('resize', resizeHandler)
  return tableMaxHeight
}

/** 手动触发一次计算（如侧栏折叠后） */
export const recalcTableMaxHeight = () => {
  resizeHandler?.()
}
